import { differenceInHours, format } from 'date-fns';
import TimeAgo from 'javascript-time-ago';

export const friendlyDateFormatter = (startDate: Date | null) => {
  const timeAgo = new TimeAgo('en-US');

  if (!startDate) {
    return '-';
  }

  const now = new Date();

  // If the date is in the future, do not use timeAgo
  if (startDate > now) {
    return format(startDate, 'MM/dd/yyyy HH:mm:ss');
  }

  const isLessThanOneHour = differenceInHours(now, startDate) < 1;

  if (isLessThanOneHour) {
    return timeAgo.format(startDate);
  } else {
    return format(startDate, 'MM/dd/yyyy HH:mm:ss');
  }
};

// Converts a 24-hour time string like "09:00" or "17:30" to a label like "9:00am" or "5:30pm".
export const formatTimeLabel = (time24h: string): string => {
  if (!time24h || typeof time24h !== 'string') return '';
  const [hStr, mStr = '00'] = time24h.split(':');
  const hour = Number.parseInt(hStr, 10);
  const minute = Number.parseInt(mStr, 10);
  if (Number.isNaN(hour) || hour < 0 || hour > 23) return '';
  const ampm = hour < 12 ? 'am' : 'pm';
  const displayHour = ((hour + 11) % 12) + 1;
  const minutePadded = String(minute).padStart(2, '0');
  return `${displayHour}:${minutePadded}${ampm}`;
};
